export default __webpack_public_path__ + "static/media/Horsens Fjord.b769157b.xlsx";